import { answerStyleStore } from '@/hooks/useAnswerStyle';
import { apiClient } from '@/utils/apiClient';

/**
 * Apply a signed-in account's answer style from a server read, and carry a
 * guest's explicit choices onto an account that has none (once — after the
 * write the account has its own, which then always wins).
 *
 * The migration write is best-effort and runs in the background, so sign-in
 * never waits on it: when it fails, this session still runs on the
 * carried-over choice, and the next sign-in tries again because the account
 * still has nothing saved. Mirrors the mobile `answerStyleSync.ts`.
 */
export async function applyAccountAnswerStyle({
  userId,
  email,
  accessToken,
  server,
  revisionAtRead,
}: {
  /** Missing only on a malformed `/auth/callback` body; nothing is applied then. */
  userId: string | undefined;
  email: string | undefined;
  accessToken: string;
  server: { answer_style?: unknown; answer_style_invite?: unknown };
  revisionAtRead?: number;
}): Promise<void> {
  if (!userId) return;
  const migration = await answerStyleStore.applyAccount(userId, server, revisionAtRead);
  if (!email || (!migration.answer_style && !migration.answer_style_invite)) return;
  // Not awaited: sign-in waits only on the local read above, never on this
  // round trip. A failure is retried at the next sign-in; see above.
  void apiClient('/user/settings', {
    method: 'POST',
    accessToken,
    body: JSON.stringify({ email, ...migration }),
  }).catch(() => undefined);
}
